import { setItemLocalStorage } from "services/util/localStorage.service";
import { getUserDetail } from "./user.session.service";

export function getPaymentMethodsSession() {
  let detail = window.localStorage[LocalStorageItems.RAAS_PAYMENT_METHODS];
  return detail ? JSON.parse(detail) : null;
}

export function setPaymentMethodsLocal(data: any) {
  const objectsArray = getPaymentMethodsSession();
    if(objectsArray!==null){
        //Comprobamos si ya tenemos el usuario agregado para modificar su valor
        const index = objectsArray.findIndex((item:any) => item.email === data.email);
        if (index !== -1) {
            //Sustituimos su valor
            objectsArray[index].id = data.id;
          } else {
            objectsArray.push(data);
          }
          setItemLocalStorage(LocalStorageItems.RAAS_PAYMENT_METHODS, objectsArray);

    }else{
        const aux=[{
            id:data.id,
            email:data.email
        }
        ]
        setItemLocalStorage(LocalStorageItems.RAAS_PAYMENT_METHODS, aux);
    }
 

}


export function getPaymentMethodsUser() {
    let result=null
    const objectsArray = getPaymentMethodsSession();
    let valueUserDetail = getUserDetail().email;
    if(objectsArray){
    result=objectsArray?.find((item:any) => item.email === valueUserDetail)
    }
    return undefined as any
  }

export enum LocalStorageItems {
  RAAS_PAYMENT_METHODS = "raas-payment-methods",
}
